import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://insights.wovensolutions.io/wp-json/wp/v2/",
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
